import { Navigate, Outlet } from 'react-router-dom';
import { RoutesLink } from '@/utility/RouteLinks';
import { getToken } from '@/utility/helper';

const ProtectedLoginRoute = () => {
  const token = getToken();
  return !token ? <Outlet /> : <Navigate to={RoutesLink?.dashboard} />;
};
export default ProtectedLoginRoute;
